var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$isDev && _vm.show)?_c('div',{staticClass:"el-overlay"},[_c('span',{staticClass:"text-12 text-mid-grey abs",staticStyle:{"top":"2px","right":"4px"}},[_vm._v(_vm._s(_vm.parentName))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }